/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const updateContactBodyPriorityMax = 100;

export const updateContactBodyExpectedVersionExclusiveMin = 0;
export const updateContactBodyExpectedVersionMax = 9007199254740991;

export const UpdateContactBody = zod.object({
  destination: zod.string().optional(),
  label: zod.string().optional(),
  priority: zod.int().min(1).max(updateContactBodyPriorityMax).optional(),
  smsEnabled: zod.boolean().optional(),
  voiceEnabled: zod.boolean().optional(),
  enabled: zod.boolean().optional(),
  expectedVersion: zod
    .int()
    .gt(updateContactBodyExpectedVersionExclusiveMin)
    .max(updateContactBodyExpectedVersionMax),
});

export type UpdateContactBody = zod.input<typeof UpdateContactBody>;
export type UpdateContactBodyOutput = zod.output<typeof UpdateContactBody>;
